import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useSettingsStore = defineStore('settings', () => {
  const menuOpen = ref(false);

  return {
    menuOpen
  };
});